import React from "react";

// component
import Leftbar from "Components/Common/Leftbar";
import Header from "Components/Common/Header";
import OffRoadEmissions from "Components/Core/Reports/OffRoadEmissions";

// css
import "Assets/css/style.css";
import "Assets/css/booking-form.css";
import "Assets/css/booking-list.css";

const index = () => {
  return (
    <>
      <Header />
      <div id="wrapper">
        <Leftbar />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <OffRoadEmissions />
          </div>
        </div>
      </div>
    </>
  );
};

export default index;
